<template>
    <div
        class="account-page container-fluid page-card admin-weflix-account"
        data-aos="fade-left"
        data-aos-duration="1500"
    >
        <div class="account-tabs-card">
            <div class="account-page-heading">
                <TitlePage
                    title="Dados Bancários"
                    subtitle="Configure os dados jurídicos e financeiros para receber os repasses de suas vendas"
                    :hasMargin="true"
                />
            </div>
        </div>

        <div class="account-shell">
            <div class="account-form-panel">
                <div class="account-inner">
        <div class="formPerson flex" v-if="typePerson == 1">
            <div class="col-form-inner col-4 col-md-4 col-lg-4">
                <div class="form-group">
                  <div class="form-label">
                    <label>CPF<v-tooltip text="Campo obrigatório" location="top">
                      <template v-slot:activator="{ props }">
                        <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                      </template>
                    </v-tooltip></label>
                  </div>
                  <div class="form-input">
                    <input
                      type="text" 
                      required
                      class="form-control"
                      v-model="comercialName"
                      placeholder="video.mp4"
                      disabled
                    />
                    <!-- <small class="alertText">Campo obrigatório e deve ser preenchido corretamente.</small> -->
                    <small>Nome comercial de sua coleção, uso externo.</small>
                  </div>
                </div>
          </div>
          <div class="col-form-inner col-8 col-md-8 col-lg-8">
            <div class="form-group">
              <div class="form-label">
                <label>Nome Completo<v-tooltip text="Campo obrigatório" location="top">
                  <template v-slot:activator="{ props }">
                    <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                  </template>
                </v-tooltip></label>
              </div>
              <div class="form-input">
                <input
                  type="text" 
                  required
                  class="form-control"
                  v-model="comercialName"
                  placeholder="video.mp4"
                  disabled
                />
                <!-- <small class="alertText">Campo obrigatório e deve ser preenchido corretamente.</small> -->
                <small>Nome comercial de sua coleção, uso externo.</small>
              </div>
            </div>
      </div>

      <div class="col-form-inner col-6 col-md-6 col-lg-6">
        <div class="form-group">
          <div class="form-label">
            <label>Banco:</label>
          </div>
          <div class="form-input">
            <select
              required
              class="form-control"
              v-model="bank"
              disabled
            >
              <option value="" selected>001 - BANCO DO BRASIL S.A.</option>
            </select>
          </div>
        </div>
      </div>

          <div class="col-form-inner col-2 col-md-2 col-lg-2">
            <div class="form-group">
              <div class="form-label">
                <label>Agência<v-tooltip text="Campo obrigatório" location="top">
                  <template v-slot:activator="{ props }">
                    <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                  </template>
                </v-tooltip></label>
              </div>
              <div class="form-input">
                <input
                  type="text" 
                  required
                  class="form-control"
                  v-model="comercialName"
                  placeholder="00000"
                  disabled
                />
                <!-- <small class="alertText">Campo obrigatório e deve ser preenchido corretamente.</small> -->
                <!-- <small>Nome comercial de sua coleção, uso externo.</small> -->
              </div>
            </div>
      </div>
      <div class="col-form-inner col-1 col-md-1 col-lg-1">
        <div class="form-group">
          <div class="form-label">
            <label>Dígito<v-tooltip text="Campo obrigatório" location="top">
              <template v-slot:activator="{ props }">
                <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
              </template>
            </v-tooltip></label>
          </div>
          <div class="form-input">
            <input
              type="text" 
              required
              class="form-control"
              v-model="comercialName"
              placeholder="00000"
              disabled
            />
            <!-- <small class="alertText">Campo obrigatório e deve ser preenchido corretamente.</small> -->
            <!-- <small>Nome comercial de sua coleção, uso externo.</small> -->
          </div>
        </div>
  </div>
  <div class="col-form-inner col-2 col-md-2 col-lg-2">
    <div class="form-group">
      <div class="form-label">
        <label>Conta<v-tooltip text="Campo obrigatório" location="top">
          <template v-slot:activator="{ props }">
            <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
          </template>
        </v-tooltip></label>
      </div>
      <div class="form-input">
        <input
          type="text" 
          required
          class="form-control"
          v-model="comercialName"
          placeholder="00000"
          disabled
        />
        <!-- <small class="alertText">Campo obrigatório e deve ser preenchido corretamente.</small> -->
        <!-- <small>Nome comercial de sua coleção, uso externo.</small> -->
      </div>
    </div>
</div>
<div class="col-form-inner col-1 col-md-1 col-lg-1">
    <div class="form-group">
      <div class="form-label">
        <label>Dígito<v-tooltip text="Campo obrigatório" location="top">
          <template v-slot:activator="{ props }">
            <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
          </template>
        </v-tooltip></label>
      </div>
      <div class="form-input">
        <input
          type="text" 
          required
          class="form-control"
          v-model="comercialName"
          placeholder="00000"
          disabled
        />
        <!-- <small class="alertText">Campo obrigatório e deve ser preenchido corretamente.</small> -->
        <!-- <small>Nome comercial de sua coleção, uso externo.</small> -->
      </div>
    </div>
</div>
<div class="actionsSave">
    <button class="btnSave">Salvar</button>
  </div>
        </div> 
        <div class="formPerson flex" v-if="typePerson == 2 && hasReady">
            <div class="col-form-inner col-4 col-md-4 col-lg-4">
                <div class="form-group">
                  <div class="form-label">
                    <label>CNPJ<v-tooltip text="Campo obrigatório" location="top">
                      <template v-slot:activator="{ props }">
                        <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                      </template>
                    </v-tooltip></label>
                  </div>
                  <div class="form-input">
                    <input
                      type="text" 
                      required
                      class="form-control"
                      v-model="CNPJ"
                      v-mask="'##.###.###/####-##'"
                      placeholder="##.###.###/####-##"
                      disabled
                    />
                    <!-- <small class="alertText">Campo obrigatório e deve ser preenchido corretamente.</small> -->
                    <small>Nome comercial de sua coleção, uso externo.</small>
                  </div>
                </div>
          </div>
          <div class="col-form-inner col-8 col-md-8 col-lg-8">
            <div class="form-group">
              <div class="form-label">
                <label>Razão Social<v-tooltip text="Campo obrigatório" location="top">
                  <template v-slot:activator="{ props }">
                    <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                  </template>
                </v-tooltip></label>
              </div>
              <div class="form-input">
                <input
                  type="text" 
                  required
                  class="form-control"
                  v-model="companyName"
                  placeholder="video.mp4"
                  disabled
                />
                <!-- <small class="alertText">Campo obrigatório e deve ser preenchido corretamente.</small> -->
                <small>Nome comercial de sua coleção, uso externo.</small>
              </div>
            </div>
      </div>

      <div class="col-form-inner col-6 col-md-6 col-lg-6">
        <div class="form-group">
          <div class="form-label">
            <label>Banco:</label>
          </div>
          <div class="form-input">
            <select
              required
              class="form-control"
              v-model="bank"
              disabled
            >
            <option value="001">001 - BANCO DO BRASIL S.A.</option>
            <option value="033">033 - BANCO SANTANDER S.A.</option>
            <option value="104">104 - CAIXA ECONÔMICA FEDERAL</option>
            <option value="237">237 - BANCO BRADESCO S.A.</option>
            <option value="341">341 - BANCO ITAÚ S.A.</option>
            <option value="077">077 - BANCO INTER S.A.</option>
            <option value="260">260 - NUBANK</option>
            <option value="336">336 - BANCO C6 S.A.</option>
            <option value="290">290 - PAGSEGURO INTERNET S.A.</option>
            <option value="380">380 - PICPAY</option>
            </select>
          </div>
        </div>
      </div>

          <div class="col-form-inner col-2 col-md-2 col-lg-2">
            <div class="form-group">
              <div class="form-label">
                <label>Agência</label>
              </div>
              <div class="form-input">
                <input
                  type="text" 
                  required
                  class="form-control"
                  v-model="agency"
                  placeholder="00000"
                  disabled
                />
                <!-- <small class="alertText">Campo obrigatório e deve ser preenchido corretamente.</small> -->
                <!-- <small>Nome comercial de sua coleção, uso externo.</small> -->
              </div>
            </div>
      </div>
      <div class="col-form-inner col-1 col-md-1 col-lg-1">
        <div class="form-group">
          <div class="form-label">
            <label>Dígito</label>
          </div>
          <div class="form-input">
            <input
              type="text" 
              required
              class="form-control"
              v-model="agencyDigit"
              placeholder="00000"
              disabled
            />
            <!-- <small class="alertText">Campo obrigatório e deve ser preenchido corretamente.</small> -->
            <!-- <small>Nome comercial de sua coleção, uso externo.</small> -->
          </div>
        </div>
  </div>
  <div class="col-form-inner col-2 col-md-2 col-lg-2">
    <div class="form-group">
      <div class="form-label">
        <label>Conta</label>
      </div>
      <div class="form-input">
        <input
          type="text" 
          required
          class="form-control"
          v-model="account"
          placeholder="00000"
          disabled
        />
        <!-- <small class="alertText">Campo obrigatório e deve ser preenchido corretamente.</small> -->
        <!-- <small>Nome comercial de sua coleção, uso externo.</small> -->
      </div>
    </div>
</div>
<div class="col-form-inner col-1 col-md-1 col-lg-1">
    <div class="form-group">
      <div class="form-label">
        <label>Dígito</label>
      </div>
      <div class="form-input">
        <input
          type="text" 
          required
          class="form-control"
          v-model="accountDigit"
          placeholder="00000"
          disabled
        />
        <!-- <small class="alertText">Campo obrigatório e deve ser preenchido corretamente.</small> -->
        <!-- <small>Nome comercial de sua coleção, uso externo.</small> -->
      </div>
    </div>
</div>
<!-- <div class="actionsSave">
    <button class="btnSave" @click="editCompany" disabled>Salvar</button>
  </div> -->
        </div>
                </div>
                <Loader :hasReady="hasReady" />
            </div>
        </div>
    </div>
</template>

<script>
import ApiCompany from '@/utils/Weflix/company';
import { mapState } from 'vuex';
import Loader from '@/components/Weflix/Loader';
import TitlePage from '@/components/Weflix/titlePage.vue';

export default {
    data() {
        return {
            typePerson: 2,
            CNPJ: '',
            companyName: '',
            bank: '',
            agency: '',
            agencyDigit: '',
            account: '',
            accountDigit: '',
            state: '',
            city: '',
            hasReady: false,
            idCompany: '',
            receivablesAdvance: false,
            mediaComments: false,
            cartClosure: false,
            showInstallmentValue: false,
           
        }
    },
    computed: {
        ...mapState(['token'])
    },
    components: {
        Loader,
        TitlePage
    },
    methods: {
        changeTypePerson(id) {
            this.typePerson = id;
        },
        async getCompany() {
          try {
            const response = await ApiCompany.getCompany(this.token);
            this.companyName = response.name;
            this.CNPJ = response.idFiscal;
            this.idCompany = response.id;
            this.bank = response.bank;
            this.agency = response.branch;
            this.account = response.account;
            this.accountDigit = response.digitAccount;
            this.agencyDigit = response.digitBranch;
            this.hasReady = true;

            this.receivablesAdvance = response.anticipation === 1 ? true : false;
            this.mediaComments = response.videoComments === 1 ? true : false;
            this.cartClosure = response.cartStatus === 1 ? true : false;
            this.showInstallmentValue = response.intallmentCheckout === 1 ? true : false;

          } catch (error) {
            console.error(error);
          }
        },
        async editCompany() {
          this.hasReady = false;
          const payload = {
            "idFiscal": this.CNPJ,
            "bank": this.bank,
            "branch": this.agency,
            "digitBranch": this.agencyDigit,
            "account": this.account,
            "digitAccount": this.accountDigit,
            "name": this.companyName,
             "anticipation": this.receivablesAdvance ? 1 : 0,
            "videoComments": this.mediaComments ? 1 : 0,
            "cartStatus": this.cartClosure ? 1 : 0,
            "intallmentCheckout": this.showInstallmentValue ? 1 : 0,
          }
          try {
            const response = await ApiCompany.editCompany(this.token, this.idCompany, payload);
            this.hasReady = true;
          } catch (error) {
            console.error(error);
          }
        }
    },
    created() {
        this.getCompany();
    }
}
</script>


<style scoped>
    @import url(./global.css);
    @import url('@/css/weflix/admin/account.css');

    .account-page.container-fluid.page-card {
        background: #f4f5f8;
        border-radius: 16px;
        padding: 0 0 1rem;
        box-shadow: 0 1px 3px rgba(37, 8, 145, 0.06);
    }

    .account-tabs-card {
        padding: 1rem;
    }

    .account-page-heading {
        padding: 1rem 1.1rem;
        background: #fff;
        border: 1px solid #e8eaf0;
        border-radius: 14px;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
    }

    .account-shell {
        padding: 0 1.5rem 1.5rem;
        height: calc(100vh - 210px);
        overflow-y: auto;
        min-height: 0;
        box-sizing: border-box;
        scrollbar-width: none;
        -ms-overflow-style: none;
    }

    .account-shell::-webkit-scrollbar {
        display: none;
    }

    .account-form-panel {
        background: #fff;
        border: 1px solid #e8eaf0;
        border-radius: 14px;
        padding: 1.25rem 1.35rem 1.5rem;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
        min-height: 0;
    }

    .account-inner {
        width: 100%;
        max-width: 100%;
    }

    .account-form-panel :deep(.titlelayoutGeneric) {
        margin-bottom: 0 !important;
        padding-bottom: 0 !important;
        border-bottom: none !important;
    }

    .account-page-heading :deep(.titlelayoutGeneric) {
        margin: 0 !important;
        padding: 0 !important;
        border-bottom: none !important;
    }

    .account-form-panel :deep(.formPerson.flex) {
        gap: 1rem 1.25rem;
        row-gap: 1.25rem;
    }

    .itens-flex {
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
        align-items: flex-start;
    }

    .itens-flex > * {
        flex: 1 1 200px;
        margin: 8px 0;
    }

    @media (max-width: 768px) {
        .account-shell {
            padding: 0 1rem 1.25rem;
        }

        .account-form-panel {
            padding: 1rem;
        }

        .account-page-heading {
            padding: 0.85rem 1rem;
        }
    }
</style>
